export default "__VITE_ASSET__DnuQyLiO__"